export default {"src":"/_next/static/media/dreaming.c682a58d.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};